package org.matthewo.hooks

import react.dom.DOMAttributes
import react.dom.events.MouseEvent
import react.dom.events.PointerEvent
import react.useRef
import kotlin.time.Duration
import kotlin.time.Duration.Companion.seconds
import kotlin.time.DurationUnit

fun useMouseEvents(
    longPressTime: Duration = 1.seconds,
    onClick: ((MouseEvent<*, *>) -> Unit)? = null,
    onLongPress: ((MouseEvent<*, *>) -> Unit)? = null,
): DOMAttributes<*>.() -> Unit {
    var mouseDown by useRef<Double>()::current
    var suppressClick by useRef(false)::current

    return {
        fun pointerUp(event: PointerEvent<*>) {
            val start = mouseDown ?: return

            val longPressTimeMillis = longPressTime.toDouble(DurationUnit.MILLISECONDS)
            if (event.timeStamp - start > longPressTimeMillis) {
                onLongPress?.invoke(event)
                suppressClick = true
            }

            mouseDown = null
        }

        onPointerDown = {
            mouseDown = it.timeStamp
            suppressClick = false
        }
        onPointerUp = { pointerUp(it) }
        onPointerLeave = { pointerUp(it) }
        onPointerCancel = { mouseDown = null }
        this.onClick = {
            if (true == suppressClick) it.preventDefault()
            else onClick?.invoke(it)
        }
    }
}
